
<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="usuarioPermitido else semPermissao">
		<div class="row">
			<div class="col">
				<h3>Limite de contratação {{ !ehFGBS ? ' da cesta atual' : ''}}</h3>
			</div>
			<div class="col-auto">
				<button type="button" class="btn btn-primary" (click)="voltarParaLista()">{{ modoEdicao ? "Cancelar" : "Voltar"}}</button>

				<button *ngIf="modoEdicao" type="button" class="btn btn-primary"
					[disabled]="!usuarioPodeEditar || !limiteFundoForm?.valid" (click)="salvar()">Enviar
				</button>

        <button *ngIf="!modoEdicao && usuarioPermitido" type="button" class="btn btn-primary"
					ngbTooltip= "Utilize esta opção para atualizar o valor do limite"
				  (click)="novoCadastro()">Atualizar limite
        </button>

				<button *ngIf="!modoEdicao && usuarioPodeEditar" type="button" class="btn btn-primary"
          ngbTooltip="Utilize esta opção apenas se o valor tiver sido cadastrado incorretamente e você desejar corrigi-lo"
          (click)="habilitarEdicao()">Corrigir limite
          </button>
			</div>
		</div>

		<div class="row" *ngIf="limiteFundoForm" [formGroup]="limiteFundoForm">
			<div class="bn-form-group col-md-4">
				<label><b>Val. limite anterior (ref.: {{limiteFundoPrevio?.dataReferencia | date: 'dd/MM/yyyy'}})</b></label>
				<input type="text" class="form-control text-end" id="valorTotalLimitePrevio"
					name="valorTotalLimitePrevio" formControlName="valorTotalLimitePrevio" bnMask="MOEDA"
					[disabled]="true" />
			</div>
			<div class="bn-form-group col-md-4">
				<label for="dataReferencia"><b>Data de referência:</b></label>
				<bn-datepicker name="dataReferencia" idInput="dataReferencia" formControlName="dataReferencia" [disabled]="!modoEdicao">
				</bn-datepicker>
			</div>
			
			<div class="bn-form-group col-md-4">

				<label *ngIf="!ehModalidadePEAC()"><b>Val. limite total: </b></label>
				<label *ngIf="ehModalidadePEAC()"><b>Valor limite total sem renúncia: </b></label>
				
				<input type="text" class="form-control text-end" id="valorLimiteTotalContratacao"
					name="valorLimiteTotalContratacao" formControlName="valorLimiteTotalContratacao" bnMask="MOEDA"
					(change)="mudancaValor($event.target.value)" [disabled]="!modoEdicao" />
			</div>

			<div class="col-md-3" *ngIf="existeApuracaoRenuncia">
				<label><b>Bimestre de apuração renúncia: </b></label>
				<input type="text" class="form-control text-start"
					 [value]="bimestreApuracaoRenuncia" bnMask="MOEDA" [disabled]="true"/>
			</div>

			<div class="col-md-4 offset-md-1" *ngIf="existeApuracaoRenuncia">
				<label><b>Valor total renunciado descomprometido apurado: </b></label>
				<input type="text" class="form-control text-end" 
				    id="valorTotalRenunciadoDescomprometidoApurado" name="valorTotalRenunciadoDescomprometidoApurado" 
					formControlName="valorTotalRenunciadoDescomprometidoApurado" bnMask="MOEDA" />
			</div>
			
			<div class="col-md-4" *ngIf="existeApuracaoRenuncia && exibirCampoValorTotalNovo">
				 
				<label class="cor-verde"><b> Valor total do novo limite de contratação : </b></label>
				<input type="text" class="form-control text-end" 
				id="valorTotalNovoLimiteContratacao" name="valorTotalNovoLimiteContratacao" 
				formControlName="valorTotalNovoLimiteContratacao" bnMask="MOEDA" />
						
			</div>
		
			<div class="col-md-6" *ngIf="existeApuracaoRenuncia">
                <br>
			</div>

		  			
			<div class="col-md-12">

				<label><b>Comentários ou justificativa</b></label>
				<textarea minlength="2" maxlength="1000" class="form-control" name="comentario" rows="4" formControlName="comentarios"></textarea>
			</div>
		</div>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
	<div class="table-responsive">
		<table class="table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center">Erro(s) encontrado(s)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ocorrencia of ocorrencias">
					<td>{{ ocorrencia.mensagem }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<ng-template #semPermissao>
	<div class="row">
		<div class="col">
			<h3>Você não possui acesso a esta página...</h3>
		</div>
	</div>
  </ng-template>
